import React, { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as queryString from 'querystring';
import { Pyramid } from '../home/pyramid/Pyramid';
import { usePublicTenantInfo } from '../../api/public/usePublic';
import { Box, Grid } from '@material-ui/core';
import { Header } from '../../components/header/Header';
import { ChallengesList } from '../home/challenges/ChallengesList';
import { ResultsList } from '../home/game/gameresult/ResultsList';
import { TitledCard } from '../../components/layout/TitledCard';
import { cupAuthService } from '../../auth/cupAuthService';

export const ReadOnlyCupPage = (): ReactElement => {
  const { search } = useLocation();
  const queryParams = queryString.parse(search.replace('?', '')) as {};
  const key = queryParams['param'];
  const { data } = usePublicTenantInfo(key);

  useEffect(() => {
    cupAuthService().logout();
  }, []);

  return (
    <>
      <Header title={data?.tenantName || ''} readonly={true} />
      <Grid container style={{ padding: '8px', gap: '16px' }}>
        <Grid item xs={12}>
          <TitledCard title={'Rangliste'}>
            <Box display="flex" width="100%">
              <Pyramid readonlyPlayers={data?.players || []} />
            </Box>
          </TitledCard>
        </Grid>
        <Grid md={2} xs={12}></Grid>
        <Grid md={4} xs={12}>
          <TitledCard title={'Offene Forderungen'}>
            <Box display="flex" width="100%">
              <ChallengesList readonlyOpenGames={data?.openGames || []} />
            </Box>
          </TitledCard>
        </Grid>
        <Grid md={4} xs={12}>
          <TitledCard title={'Ergebnisse'}>
            <Box display="flex" width="100%">
              <ResultsList readonlyFinishedGames={data?.results || []} />
            </Box>
          </TitledCard>
        </Grid>
      </Grid>
    </>
  );
};
